module.exports = __webpack_public_path__ + "static/media/ApercuPro-Regular.90338ebe.woff2";